import { CustomEvents } from './CustomEvents';
export const EVENT_HANDLERS = {
  // Menu events
  [CustomEvents.HEADER_EVENTS.menuOpen]: {
    stateKey: 'menuOpen',
    getValue: (data) => data.payload
  },
  // Login events
  [CustomEvents.LOGIN_POPUP_EVENTS.show]: {
    stateKey: 'loginOpen',
    getValue: () => true
  },
  [CustomEvents.LOGIN_POPUP_EVENTS.hide]: {
    stateKey: 'loginOpen',
    getValue: () => false
  },
  // Search events
  [CustomEvents.SEARCH_LAYER_EVENTS.open]: {
    stateKey: 'searchOpen',
    getValue: () => true
  },
  [CustomEvents.SEARCH_LAYER_EVENTS.closed]: {
    stateKey: 'searchOpen',
    getValue: () => false
  },
  // Chat events
  [CustomEvents.CHAT_EVENTS.opened]: {
    stateKey: 'chatOpen',
    getValue: () => true
  },
  [CustomEvents.CHAT_EVENTS.minimize]: {
    stateKey: 'chatOpen',
    getValue: () => false
  },
  [CustomEvents.CHAT_EVENTS.unminimize]: {
    stateKey: 'chatOpen',
    getValue: () => true
  },
  [CustomEvents.CHAT_EVENTS.closed]: {
    stateKey: 'chatOpen',
    getValue: () => false
  }
};

export default class TimerController {

  constructor({
                delay,
                onComplete = () => {},
                shouldPauseFn = () => false,
                onPause = () => {},
                onResume = () => {},
                onStart = () => {}
              }) {

    this.initialDelay = delay;
    this.remainingTime = delay;
    this.startTime = null;
    this.timerId = null;
    this.isPaused = false;
    this.pauseBeforeResume = 2000
    this.isDestroyed = false;
    this.resumeTimer = null;


    this.shouldPauseFn = shouldPauseFn;
    this.onComplete = onComplete;
    this.onPause = onPause;
    this.onResume = onResume;
    this.onStart = onStart;
  }

  start() {
    if (this.isDestroyed || this.shouldPauseFn()) {
      this.isPaused = true;
      return;
    }

    this.startTime = Date.now();
    this.isPaused = false;

    this.timerId = setTimeout(() => this._handleComplete(), this.remainingTime);
    this.onStart(this.getProgress(), this.remainingTime);
  }

  pause() {
    if (this.isPaused || this.isDestroyed) return;

    this.isPaused = true;
    const elapsed = Date.now() - this.startTime;
    this.remainingTime = Math.max(0, this.remainingTime - elapsed);

    clearTimeout(this.timerId);
    this.timerId = null;

    this.onPause(this.getProgress(), this.remainingTime);
  }

  resume() {
    if (!this.isPaused || this.isDestroyed) return;

    if (this.resumeTimer) {
      clearTimeout(this.resumeTimer);
    }

    this.resumeTimer = setTimeout(() => {
      if (!this.isDestroyed && this.remainingTime > 0 && !this.shouldPauseFn()) {
        this.start();
        this.onResume(this.getProgress(), this.remainingTime);
      }
    }, this.pauseBeforeResume); // seconds pause before resuming the countdown.
  }

  reset() {
    if (this.isDestroyed) return;
    this.pause();
    this.remainingTime = this.initialDelay;
    this.isPaused = false;
  }

  getProgress() {
    if (this.initialDelay === 0) return 100;
    return Math.round(((this.initialDelay - this.remainingTime) / this.initialDelay) * 100);
  }

  _handleComplete() {
    if (this.isDestroyed) return;
    if (!this.shouldPauseFn()) {
      this.onComplete();
      this.destroy();
    } else {
      this.pause();
    }
  }

  destroy() {
    this.isDestroyed = true;
    clearTimeout(this.timerId);
    clearTimeout(this.resumeTimer);
    this.timerId = null;
    this.resumeTimer = null;
  }
}

export const bindTimerStateEvents = function() {
  Object.entries(EVENT_HANDLERS).forEach(([event, { stateKey, getValue }]) => {
    this.$on(event, (data) => {
      const newValue = getValue(data);
      if (this.layerStates[stateKey] !== newValue) {
        this.layerStates[stateKey] = newValue;
        this.handleTimerStateChange();
      }
    });
  });
};
